<template>
  <div>
    <nav class="navbar navbar-expand-lg fixed-top navbar-light bg-white border-bottom">
      <div class="container">
        <router-link to="/" class="navbar-brand">
          <img src="@/assets/horga-x-logo1.webp" alt="HORGA X" class="navbar-logo">
        </router-link>

        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarTogglerDemo02">
          <ul class="navbar-nav mr-auto mt-2 mt-lg-0"></ul>
          <ul class="navbar-nav my-lg-0" style="font-size: 18px;">
            <li class="nav-item mb-0 mx-2" :class="{ active: isProductNavActive }">
              <router-link class="nav-link menu-text" to="/list?type=product">สินค้าทั้งหมด</router-link>
            </li>
            <li class="nav-item mb-0 mx-2" :class="{ active: isServiceNavActive }">
              <router-link class="nav-link menu-text" to="/list?type=service">บริการทั้งหมด</router-link>
            </li>
            <li class="nav-item dropdown mb-0 mx-2">
              <a
                class="nav-link menu-text dropdown-toggle"
                href="#"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                โซลูชันสำหรับ
              </a>
              <div class="dropdown-menu">
                <router-link class="dropdown-item" :to="{ path: '/list', query: { solution: 'apartment' } }">หอพัก อพาร์ทเมนท์</router-link>
                <router-link class="dropdown-item" :to="{ path: '/list', query: { solution: 'market' } }">ตลาด / คอมมูนิตี้มอลล์</router-link>
              </div>
            </li>
            <li class="nav-item mb-0 ml-2">
              <router-link class="nav-link menu-text" to="/contact">ติดต่อเรา</router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <!-- <nav class="navbar fixed-top" id="nav">
      <div class="container" >
        <div class="home" @click="goToHomePage()">
          <img src="../assets/images/brand-icon.png" class="d-inline" alt="" width="40px">
          <h3 class="text-logo d-inline" style="margin:5px;">MarketPlace</h3>
        </div>
        
        <span class="initialize" v-if="user"  id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <div class="box-image-profile">
            <img :src="`https://images.horganice.in.th/users/thumbnails/${user.id}.jpg`" v-if="!isNoImage" @error="errorImage()" alt="" >
            <img src="../assets/images/default-user-image.png" v-if="isNoImage">
          </div>
          {{ user.get('userProfile').get('firstName') }} 
          <span class="fa fa-caret-down"></span>

          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item" @click="logout()">ออกจากระบบ</a>
          </div>
        </span>
        
        
        <span class="initialize" v-else>
          <a :href="`${$webAppUrl}/login?redirect=marketplace`" class="initialize-menu" target="_blank"><span class="fas fa-user-circle" style="font-size:23px; position:relative; top: 2px;"></span>  เข้าสู่ระบบ</a> | <a :href="`${$webAppUrl}/pre-signup?utm_source=marketplace`" target="_blank" class="initialize-menu">สมัครสมาชิก</a>
        </span>

      </div>
    </nav> -->
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      isNoImage: false
    }
  },
  computed:{
    ...mapState([
      'apartment',
      'carts',
      'user'
    ]),
    isProductNavActive() {
      if (this.$route.path !== '/list') return false
      const { type, solution, category } = this.$route.query
      if (type === 'service' || solution || category) return false
      return !type || type === 'product'
    },
    isServiceNavActive() {
      return this.$route.path === '/list' && this.$route.query.type === 'service'
    },
  },
  methods:{
    goToHomePage(){
      $("#main-cid-detail").removeClass("modal-open");
      $("#modal-purchase").addClass("modal-purchase-hide");
      if(this.carts && this.carts.length > 0){
        $("#cart-bar").removeClass("hide-cart");
        $("#cart-bar").addClass("show-cart");
      }
      this.$router.push({ name: 'home'})
    },
    async logout(){

      await this.Parse.User.logOut();
      location.replace("/")
    },
    errorImage(){
      this.isNoImage = true
    }
  }
}
</script>

<style scoped lang="scss">
.navbar {
  min-height: 74px;
  padding-top: 16px;
  padding-bottom: 16px;
}
.navbar-logo {
  height: 26px;
  width: auto;
}
.menu-text {
  height: 100%;
  color: var(--secondary) !important;
}
.menu-text:hover,
.nav-item.active .menu-text {
  color: var(--primary) !important;
}
</style>
